// extracted by mini-css-extract-plugin
export default {"root":"AllChecksTable_root__n+s2e"};